export interface AppConfig {
  env: string;
  region: string;
  subdomain: string;
  hostedZoneName: string;
  apiEndpoint: string;
  authDomain: string;
  cognitoIdentityPoolId: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  signupEnabled: boolean;
}

const requiredVars = [
  ['VITE_ENV', 'env'],
  ['VITE_REGION', 'region'],
  ['VITE_SUBDOMAIN', 'subdomain'],
  ['VITE_HOSTED_ZONE_NAME', 'hostedZoneName'],
  ['VITE_API_ENDPOINT', 'apiEndpoint'],
  ['VITE_AUTH_DOMAIN', 'authDomain'],
  ['VITE_COGNITO_IDENTITY_POOL_ID', 'cognitoIdentityPoolId'],
  ['VITE_COGNITO_USER_POOL_ID', 'cognitoUserPoolId'],
  ['VITE_COGNITO_CLIENT_ID', 'cognitoClientId'],
] as const;

export function getConfig(): AppConfig {
  const missing: string[] = [];
  const values: Record<string, string> = {};

  for (const [envVar, field] of requiredVars) {
    const value = import.meta.env[envVar];
    if (!value || value.trim() === '') {
      missing.push(envVar);
    } else {
      values[field] = value;
    }
  }

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variable(s): ${missing.join(', ')}. ` +
      `Ensure these are set in your .env file or .env.local.`
    );
  }

  return {
    ...values,
    signupEnabled: import.meta.env.VITE_SIGNUP_ENABLED !== 'false',
  } as unknown as AppConfig;
}

let _config: AppConfig | null = null;

/** Singleton config instance — lazily initialized on first access. */
export const config: AppConfig = new Proxy({} as AppConfig, {
  get(_target, prop: string) {
    if (!_config) {
      _config = getConfig();
    }
    return _config[prop as keyof AppConfig];
  },
});
